export default "__VITE_ASSET__BekI9uhy__"